import React from 'react'
import { Link, Paper, Typography, useMediaQuery, useTheme } from '@mui/material'

const Security: React.FC = () => {
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Paper sx={{ margin: downSm ? '0px' : '32px', padding: downSm ? '8px' : '32px' }}>
      <Typography variant='h1'>Datenschutzerklärung</Typography>
      <Typography variant='h2'>Allgemeiner Hinweis und Pflichtinformationen</Typography>
      <Typography variant='subtitle2'>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website
        ist:
      </Typography>
      <Typography variant='body1'>KD Design<br />
        Kristin Dietze<br />
        Maxim-Gorki-Str. 7a<br />
        01445 Radebeul
      </Typography>
      <Typography variant='body1'>Die verantwortliche Stelle entscheidet allein oder gemeinsam mit anderen über
        die
        Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, Kontaktdaten o.
        Ä.).
      </Typography>
      <Typography variant='subtitle2'>Widerruf Ihrer Einwilligung zur Datenverarbeitung</Typography>
      <Typography variant='body1'>Nur mit Ihrer ausdrücklichen Einwilligung sind einige Vorgänge der
        Datenverarbeitung
        möglich. Ein Widerruf
        Ihrer bereits erteilten Einwilligung ist jederzeit möglich. Für den Widerruf genügt eine formlose
        Mitteilung per
        E-Mail. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf
        unberührt.
      </Typography>
      <Typography variant='subtitle2'>Recht auf Beschwerde bei der zuständigen Aufsichtsbehörde</Typography>
      <Typography variant='body1'>
        Als Betroffener steht Ihnen im Falle eines datenschutzrechtlichen Verstoßes ein Beschwerderecht bei der
        zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde bezüglich datenschutzrechtlicher Fragen ist der
        Landesdatenschutzbeauftragte des Bundeslandes, in dem sich der Sitz unseres Unternehmens befindet. Der
        folgende Link stellt eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten bereit:{' '}
        <Link
          color={theme.palette.primary.dark}
          href='https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html'
          target='_blank'
        >
          https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html
        </Link>
        .
      </Typography>
      <Typography variant='subtitle2'>Recht auf Datenübertragbarkeit</Typography>
      <Typography variant='body1'>Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer Einwilligung oder
        in
        Erfüllung eines Vertrags
        automatisiert verarbeiten, an sich oder an Dritte aushändigen zu lassen. Die Bereitstellung erfolgt in
        einem
        maschinenlesbaren Format. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen
        verlangen, erfolgt dies nur, soweit es technisch machbar ist.
      </Typography>
      <Typography variant='subtitle2'>Recht auf Auskunft, Berichtigung, Sperrung, Löschung</Typography>
      <Typography variant='body1'>Sie haben jederzeit im Rahmen der geltenden gesetzlichen Bestimmungen das
        Recht auf
        unentgeltliche Auskunft
        über Ihre gespeicherten personenbezogenen Daten, Herkunft der Daten, deren Empfänger und den Zweck der
        Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.
        Diesbezüglich und
        auch zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit über die im Impressum
        aufgeführten Kontaktmöglichkeiten an uns wenden.
      </Typography>
      <Typography variant='subtitle2'>SSL- bzw. TLS-Verschlüsselung</Typography>
      <Typography variant='body1'>Aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte,
        die Sie
        an uns als Seitenbetreiber
        senden, nutzt unsere Website eine SSL-bzw. TLS-Verschlüsselung. Damit sind Daten, die Sie über diese
        Website
        übermitteln, für Dritte nicht mitlesbar. Sie erkennen eine verschlüsselte Verbindung an der „https://“
        Adresszeile Ihres Browsers und am Schloss-Symbol in der Browserzeile.
      </Typography>
      <Typography variant='h2'>Registrierung auf dieser Website</Typography>
      <Typography variant='body1'>Zur Nutzung bestimmter Funktionen können Sie sich auf unserer Website
        registrieren.
        Die übermittelten Daten
        dienen ausschließlich zum Zwecke der Nutzung des jeweiligen Angebotes oder Dienstes. Bei der
        Registrierung
        abgefragte Pflichtangaben sind vollständig anzugeben. Andernfalls werden wir die Registrierung
        ablehnen.
      </Typography>
      <Typography variant='body1'>Im Falle wichtiger Änderungen, etwa aus technischen Gründen, informieren wir
        Sie per
        E-Mail. Die E-Mail wird an
        die Adresse versendet, die bei der Registrierung angegeben wurde.
      </Typography>
      <Typography variant='body1'>Die Verarbeitung der bei der Registrierung eingegebenen Daten erfolgt auf
        Grundlage
        Ihrer Einwilligung (Art. 6
        Abs. 1 lit. a DSGVO). Ein Widerruf Ihrer bereits erteilten Einwilligung ist jederzeit möglich. Für den
        Widerruf
        genügt eine formlose Mitteilung per E-Mail. Die Rechtmäßigkeit der bereits erfolgten Datenverarbeitung
        bleibt
        vom Widerruf unberührt.
      </Typography>
      <Typography variant='body1'>Wir speichern die bei der Registrierung erfassten Daten während des Zeitraums,
        den
        Sie auf unserer Website
        registriert sind. Ihren Daten werden gelöscht, sollten Sie Ihre Registrierung aufheben. Gesetzliche
        Aufbewahrungsfristen bleiben unberührt.
      </Typography>
      <Typography variant='h2'>Google Maps</Typography>
      <Typography variant='subtitle2'>Art und Umfang der Verarbeitung</Typography>
      <Typography variant='body1'>Wir verwenden zur Erstellung von Anfahrtsbeschreibungen den Kartendienst
        Google
        Maps. Google Maps ist ein
        Dienst der Google Ireland Limited, welcher auf unserer Website eine Karte darstellt. Wenn Sie auf diese
        Inhalte
        unserer Website zugreifen, stellen Sie eine Verbindung zu Servern der Google Ireland Limited, Gordon
        House,
        Barrow Street, Dublin 4, Irland her, wobei Ihre IP-Adresse und ggf. Browserdaten wie Ihr User-Agent
        übermittelt
        werden. Diese Daten werden ausschließlich zu den oben genannten Zwecken und zur Aufrechterhaltung der
        Sicherheit
        und Funktionalität von Google Maps verarbeitet.
      </Typography>
      <Typography variant='subtitle2'>Zweck und Rechtsgrundlage</Typography>
      <Typography variant='body1'>Der Einsatz von Google Maps erfolgt auf Grundlage Ihrer Einwilligung gemäß
        Art. 6
        Abs. 1 lit. a. DSGVO und § 25
        Abs. 1 TTDSG.
      </Typography>
      <Typography variant='body1'>
        Wir beabsichtigen personenbezogenen Daten an Drittländer außerhalb des Europäischen Wirtschaftsraums,
        insbesondere die USA, zu übermitteln. In Fällen, in denen kein Angemessenheitsbeschluss der Europäischen
        Kommission existiert (z.B. in den USA) haben wir mit den Empfängern der Daten anderweitige geeignete Garantien
        im Sinne der Art. 44 ff. DSGVO vereinbart. Dies sind – sofern nicht anders angegeben – Standardvertragsklauseln
        der EU-Kommission gemäß Durchführungsbeschluss (EU) 2021/914 vom 4. Juni 2021. Eine Kopie dieser
        Standardvertragsklauseln können Sie unter{' '}
        <Link
          color={theme.palette.primary.dark}
          href='https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32021D0914&from=DE'
          target='_blank'
        >
          https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32021D0914&from=DE
        </Link>
        {' '}einsehen.
      </Typography>
      <Typography variant='body1'>Zudem holen wir vor einem solchen Drittlandtransfer Ihre Einwilligung nach
        Art. 49
        Abs. 1 Satz 1 lit. a. DSGVO
        ein, die Sie über die Einwilligung im Consent Manager (oder sonstigen Formularen, Registrierungen etc.)
        erteilen. Wir weisen Sie darauf hin, dass bei Drittlandübermittlungen im Detail unbekannte Risiken (z.B.
        die
        Datenverarbeitung durch Sicherheitsbehörden des Drittlandes, deren genauer Umfang und deren Folgen für
        Sie wir
        nicht kennen, auf die wir keinen Einfluss haben und von denen Sie unter Umständen keine Kenntnis
        erlangen)
        bestehen können.
      </Typography>
      <Typography variant='subtitle2'>Speicherdauer</Typography>
      <Typography variant='body1'>
        Die konkrete Speicherdauer der verarbeiteten Daten ist nicht durch uns beeinflussbar, sondern wird von Google
        Ireland Limited bestimmt. Weitere Hinweise finden Sie in der Datenschutzerklärung für Google Maps:{' '}
        <Link
          color={theme.palette.primary.dark}
          href='https://policies.google.com/privacy'
          target='_blank'
        >
          https://policies.google.com/privacy
        </Link>
        .
      </Typography>
    </Paper>
  )
}

export default Security
